<template>
  <permissions-view
    :site="site"
    :section="section"
  >
    <v-container>
      <permits
        :site="site"
        :auto-open="autoOpen"
      />
    </v-container>
  </permissions-view>
</template>

<script>
  import DisplayField from '@/components/DisplayField'
  import DatePicker from '@/components/DatePicker'
  import STextarea from '@/components/Textarea'
  import TextField from '@/components/TextField'
  import ReactivityMixin from '@/mixins/Reactivity'
  import FormActions from '@/components/FormActions'
  import TypePermit from '@/components/codelist/TypePermit'
  import PermitStatus from '@/components/codelist/PermitStatus'
  import SitePermitMinistryHealthService from '@/services/site-permit-ministry-health.vue'
  import FileUpload from '@/components/FileUpload'
  import EmptySpace from '@/components/EmptySpace'
  import PermissionsView from '@/components/PermissionsView'
  import PermissionsMixin from '@/mixins/Permissions'
  import Permits from '@/views/sites/sections/permit-ministry-health/Permits'
  export default {
    name: 'PermitMinistryOfHealth',
    components: { Permits, PermissionsView, EmptySpace, FileUpload, PermitStatus, TypePermit, FormActions, TextField, STextarea, DatePicker, DisplayField },
    mixins: [
      ReactivityMixin,
      PermissionsMixin,
    ],
    props: {
      site: {
        default: null,
      },
      active: {
        default: false,
      },
      autoOpen: {
        default: false,
      },
    },
    data: () => ({
      loading: false,
      saved: false,
      permit: null,
      section: 'permit_ministry_of_health',
    }),
    mounted () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        const ls = new SitePermitMinistryHealthService(this.site.id)
        ls.getSingle().then((response) => {
          this.permit = response.data.data
          if (Array.isArray(this.permit)) {
            this.permit = {}
          }
        })
      },
    },
  }
</script>

<style scoped>

</style>
